import { topicsData, indexData, contactData } from '@/mocks/homeData';

export function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-hashtag text-primary-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">话题热榜</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">全网最火吃瓜话题，热度实时更新</p>

          <div className="flex flex-wrap gap-2 md:gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href={`#cards`}
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group inline-flex items-center gap-2 px-3 py-2 md:px-4 md:py-2.5 rounded-full bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <span className="text-xs whitespace-nowrap">{topic.trend}</span>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap transition-colors">
                  {topic.name}
                </span>
                <span className="text-xs font-semibold text-primary-500 whitespace-nowrap">{topic.heat}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-stack-line text-accent-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">专题合集</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">精选分类，快速找到你感兴趣的吃瓜内容</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {indexData.map((item) => (
              <a
                key={item.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex items-start gap-3 p-4 md:p-5 rounded-lg bg-background-50 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 group-hover:bg-accent-200 transition-colors shrink-0">
                  <i className={`${item.icon} text-accent-600 text-lg`}></i>
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors mb-1 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-1.5">{item.desc}</p>
                  <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-send-plane-line text-primary-600 text-sm"></i>
            </span>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">{contactData.title}</h2>
          </div>
          <p className="text-sm text-foreground-500 mb-6 md:mb-8 ml-11">{contactData.description}</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 ml-0 md:ml-11">
            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                <i className="ri-mail-line text-primary-600"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">投稿邮箱</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 shrink-0">
                <i className="ri-wechat-line text-accent-600"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">官方微信</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.wechat}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 shrink-0">
                <i className="ri-shield-check-line text-secondary-600"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">我们承诺</p>
                <div className="flex flex-wrap gap-1.5">
                  {contactData.tips.map((tip) => (
                    <span key={tip} className="text-xs font-medium text-foreground-700 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {tip}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}